import RoundedButtonLinkSecondary from '../../components/button/rounded-button-link-secondary/RoundedButtonLinkSecondary';
import GiveRecurringPaymentForOrgPage from '../../project/payment/give-external-support/GiveRecurringPaymentForOrgPage';
import styles from './organization-recurring.module.less';

const OrganizationRecurring = ({ organization, editable }) => {
    const link = `/org/${organization.id}/control/recurring/settings`;
    return (
        <div className={styles.wrapper}>
            <GiveRecurringPaymentForOrgPage
                organizationId={organization.id}
                organizationName={organization.name}
                organizationNumber={organization.organization_number}
                logoUrl={organization.recurring_giver_recruitment_config?.logo}
                roundedLogoUrl={organization.img_url}
                imageUrl={organization?.recurring_giver_recruitment_config?.image}
                title={organization?.recurring_giver_recruitment_config?.title}
                text={organization?.recurring_giver_recruitment_config?.text}
                predefinedAmounts={organization?.recurring_giver_recruitment_config?.predefinedAmounts}
            />
            {editable && (
                <RoundedButtonLinkSecondary to={link}>
                    <i className={'fa-regular fa-pen-to-square'} />
                    <span className={styles.adminLinkText}>Rediger faste givere</span>
                </RoundedButtonLinkSecondary>
            )}
        </div>
    );
};

export default OrganizationRecurring;
